/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Highestpriceincrease2Inputs */

const he_statistics_highestpriceincrease2 = /** @type {(inputs: Statistics_Highestpriceincrease2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עליות מחיר למחיר הגבוה ביותר`)
};

const en_statistics_highestpriceincrease2 = /** @type {(inputs: Statistics_Highestpriceincrease2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price increases to highest price`)
};

/**
* | output |
* | --- |
* | "Price increases to highest price" |
*
* @param {Statistics_Highestpriceincrease2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_highestpriceincrease2 = /** @type {((inputs?: Statistics_Highestpriceincrease2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Highestpriceincrease2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_highestpriceincrease2(inputs)
	return en_statistics_highestpriceincrease2(inputs)
});
export { statistics_highestpriceincrease2 as "statistics_highestPriceIncrease" }